import { ClubMembershipState } from "./clubPage.tsx";
import { ApprovalBox } from "./approvalBox.tsx";
import { ApprovalRequiredBox } from "./approvalRequiredBox.tsx";
import { AlreadyLinkedBox } from "./alreadyLinkedBox.tsx";

export interface ApprovalRequestedFragmentProps {
  state: ClubMembershipState;
}

ApprovalRequestedFragment.tagName = "control-approval-requested-fragment";

export function ApprovalRequestedFragment(props: ApprovalRequestedFragmentProps) {
  return (
    <>
      {props.state === ClubMembershipState.ApprovalRequested && <ApprovalBox />}
      {props.state === ClubMembershipState.ApprovalRequired && <ApprovalRequiredBox />}
      {props.state === ClubMembershipState.AlreadyLinked && <AlreadyLinkedBox />}
    </>
  );
}
